/* @flow */
import cx from 'classnames';
import Heading from 'components/Heading.jsx';
import React from 'react';

import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/DialogSidebar.scss';

class DialogSidebar extends React.Component {
  static propTypes = {
    title: React.PropTypes.node,
    color: React.PropTypes.oneOf([
      'grey', 'white',
    ]),
  };

  static propClasses = {
    color: {
      grey: 'DialogSidebar-grey',
    },
  };

  renderTitle = () => {
    const { title } = this.props;
    if (!title) {
      return null;
    }
    return <Heading flush level="3">{title}</Heading>;
  };

  render() {
    return (
      <div
        className={cx({
          DialogSidebar: true,
        }, getPropClassesFromInstance(this), this.props.className)}>
        {this.renderTitle()}
        {this.props.children}
      </div>
    );
  }
}

export default DialogSidebar;



// WEBPACK FOOTER //
// ./src/components/DialogSidebar.jsx